import loadable from '@loadable/component';

export const SearchOrgsPageLoadable = loadable(
  () => import('./SearchOrgsPage'),
  { resolveComponent: (module) => module.SearchOrgsPage },
);
